import { createContext, ReactNode, useContext, useState } from "react";

export interface EntityIdContextType {
	entityId: number;
	setEntityId: (id: number) => void;
}

const defaultContextValues = {
	entityId: undefined,
	setEntityId: undefined,
};

export const EntityIdContext = createContext<EntityIdContextType>(defaultContextValues);

export const useEntityIdContext = () => useContext(EntityIdContext);

interface EntityIdProviderProps {
	entityId: number | undefined;
	children: ReactNode;
}

export function EntityIdProvider(props: EntityIdProviderProps) {
	const { children } = props;

	const [entityId, set] = useState<number | undefined>(props.entityId);

	function setEntityId(id: number | undefined) {
		if (entityId == null) return;

		set(id);
	}

	return <EntityIdContext.Provider value={{ entityId, setEntityId }}>{children}</EntityIdContext.Provider>;
}
